import Layout from '@/layout';
var liveItem = function liveItem() {
  return import('@/views/pet/live/item');
};
var liveOrder = function liveOrder() {
  return import('@/views/pet/live/order');
};
var liveContract = function liveContract() {
  return import('@/views/pet/live/contract');
};
var liveAuction = function liveAuction() {
  return import('@/views/pet/live/auction');
};
var petClassify = function petClassify() {
  return import('@/views/pet/classify/index');
};
var storeAuctionIndex = function storeAuctionIndex() {
  return import('@/views/pet/auction/index');
};
var storeAuctionList = function storeAuctionList() {
  return import('@/views/pet/auction/list');
};
var storeAuctionLog = function storeAuctionLog() {
  return import('@/views/pet/auction/log');
};
var storeAuctionDeposit = function storeAuctionDeposit() {
  return import('@/views/pet/auction/deposit');
};
var storeAuctionExtract = function storeAuctionExtract() {
  return import('@/views/pet/auction/extract');
};
var storeAuctionForm = function storeAuctionForm() {
  return import('@/views/pet/auction/form');
};
var storeAuctionStatistics = function storeAuctionStatistics() {
  return import('@/views/pet/auction/statistics');
};
var petInfoIndex = function petInfoIndex() {
  return import('@/views/pet/info/index');
};
var petInfoForm = function petInfoForm() {
  return import('@/views/pet/info/form');
};
var petInfoStatistics = function petInfoStatistics() {
  return import('@/views/pet/info/statistics');
};
var petInfoSetup = function petInfoSetup() {
  return import('@/views/pet/info/setup');
};
var petInfoTop = function petInfoTop() {
  return import('@/views/pet/info/top');
};
var petRationIndex = function petRationIndex() {
  return import('@/views/pet/ration/index');
};
var storeRationForm = function storeRationForm() {
  return import('@/views/pet/ration/form');
};
var petUserIndex = function petUserIndex() {
  return import('@/views/pet/user/index');
};
var storePetHouseIndex = function storePetHouseIndex() {
  return import('@/views/pet/house/index');
};
var storePetHouseForm = function storePetHouseForm() {
  return import('@/views/pet/house/form');
};
var storePetHouseLog = function storePetHouseLog() {
  return import('@/views/pet/house/log/index');
};
var storePetHouseSeedOrderIndex = function storePetHouseSeedOrderIndex() {
  return import('@/views/pet/house/seed_order/index');
};
var petHouseRankIndex = function petHouseRankIndex() {
  return import('@/views/pet/house/rank/index');
};
var petHouseSeedIndex = function petHouseSeedIndex() {
  return import('@/views/pet/house/seed/index');
};
var petHouseTop = function petHouseTop() {
  return import('@/views/pet/house/top');
};
var petHouseClassify = function petHouseClassify() {
  return import('@/views/pet/house/classify/index');
};
var petHouseRuleLog = function petHouseRuleLog() {
  return import('@/views/pet/house/rule_log/index');
};
var houseVoteIndex = function houseVoteIndex() {
  return import('@/views/pet/vote/index');
};
var houseVoteForm = function houseVoteForm() {
  return import('@/views/pet/vote/form');
};
var houseVoteUser = function houseVoteUser() {
  return import('@/views/pet/vote/user');
};
var houseVoteRewards = function houseVoteRewards() {
  return import('@/views/pet/vote/rewards');
};
var houseVoteSeed = function houseVoteSeed() {
  return import('@/views/pet/vote/seed');
};
var houseVoteHouse = function houseVoteHouse() {
  return import('@/views/pet/vote/house');
};
var houseVoteLog = function houseVoteLog() {
  return import('@/views/pet/vote/log');
};
var chipIndex = function chipIndex() {
  return import('@/views/pet/chip/index');
};
var chipUser = function chipUser() {
  return import('@/views/pet/chip/user');
};
var chipVip = function chipVip() {
  return import('@/views/pet/chip/vip');
};
var chipBreeding = function chipBreeding() {
  return import('@/views/pet/chip/breeding');
};
var chipNameLog = function chipNameLog() {
  return import('@/views/pet/chip/name_log');
};
var chipOwner = function chipOwner() {
  return import('@/views/pet/chip/owner');
};
var chipFamily = function chipFamily() {
  return import('@/views/pet/chip/family');
};
var petCoinConfig = function petCoinConfig() {
  return import('@/views/pet/coin/config');
};
var petLabel = function petLabel() {
  return import('@/views/pet/label/cate');
};
var petRecord = function petRecord() {
  return import('@/views/pet/record/index');
};
var productForm = function productForm() {
  return import('@/views/pet/product/form');
};
var petOrder = function petOrder() {
  return import('@/views/pet/order/index');
};
var ParentView = function ParentView() {
  return import('@/layout/routerView/parent.vue');
};
var breedingFemale = function breedingFemale() {
  return import('@/views/pet/breeding/female');
};
var breedingMale = function breedingMale() {
  return import('@/views/pet/breeding/male');
};
var breedingEstrus = function breedingEstrus() {
  return import('@/views/pet/breeding/estrus');
};
var breedingMatingPage = function breedingMatingPage() {
  return import('@/views/pet/breeding/mating');
};
var breedingPregnancy = function breedingPregnancy() {
  return import('@/views/pet/breeding/pregnancy');
};
var breedingSchedule = function breedingSchedule() {
  return import('@/views/pet/breeding/schedule');
};
var breedingLitter = function breedingLitter() {
  return import('@/views/pet/breeding/litter');
};
var breedingPuppy = function breedingPuppy() {
  return import('@/views/pet/breeding/puppy');
};
var breedingCare = function breedingCare() {
  return import('@/views/pet/breeding/care');
};
var breedingPedigree = function breedingPedigree() {
  return import('@/views/pet/breeding/pedigree');
};
var breedingHealth = function breedingHealth() {
  return import('@/views/pet/breeding/health');
};
var breedingAlgorithm = function breedingAlgorithm() {
  return import('@/views/pet/breeding/algorithm');
};
var seedVideo = function seedVideo() {
  return import('@/views/pet/seed-service/video');
};
var seedComment = function seedComment() {
  return import('@/views/pet/seed-service/comment');
};
var seedPackage = function seedPackage() {
  return import('@/views/pet/seed-service/package');
};
var seedFulfillment = function seedFulfillment() {
  return import('@/views/pet/seed-service/fulfillment');
};
var petRouter = {
  path: '/pet',
  component: Layout,
  redirect: '/pet/live/item',
  name: 'Pet',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '宠物经营',
    icon: 'clipboard'
  },
  children: [{
    path: 'breeding',
    component: ParentView,
    redirect: '/pet/breeding/female',
    name: 'BreedingGroup',
    meta: {
      title: '繁育管理'
    },
    children: [{
      path: 'female',
      name: 'BreedingFemale',
      component: breedingFemale,
      meta: {
        title: '母犬档案'
      }
    }, {
      path: 'male',
      name: 'BreedingMale',
      component: breedingMale,
      meta: {
        title: '公犬档案'
      }
    }, {
      path: 'estrus',
      name: 'BreedingEstrus',
      component: breedingEstrus,
      meta: {
        title: '发情周期'
      }
    }, {
      path: 'mating',
      name: 'BreedingMatingLedger',
      component: breedingMatingPage,
      meta: {
        title: '配种台账'
      }
    }, {
      path: 'pregnancy',
      name: 'BreedingPregnancy',
      component: breedingPregnancy,
      meta: {
        title: '孕期管理'
      }
    }, {
      path: 'schedule',
      name: 'BreedingSchedule',
      component: breedingSchedule,
      meta: {
        title: '公犬档期'
      }
    }, {
      path: 'litter',
      name: 'BreedingLitter',
      component: breedingLitter,
      meta: {
        title: '幼犬窝次'
      }
    }, {
      path: 'puppy',
      name: 'BreedingPuppy',
      component: breedingPuppy,
      meta: {
        title: '幼犬个体'
      }
    }, {
      path: 'care',
      name: 'BreedingCare',
      component: breedingCare,
      meta: {
        title: '体重与护理'
      }
    }, {
      path: 'pedigree',
      name: 'BreedingPedigree',
      component: breedingPedigree,
      meta: {
        title: '血统谱系'
      }
    }, {
      path: 'health',
      name: 'BreedingHealth',
      component: breedingHealth,
      meta: {
        title: '健康医疗'
      }
    }, {
      path: 'algorithm',
      name: 'BreedingAlgorithm',
      component: breedingAlgorithm,
      meta: {
        title: '算法参数'
      }
    }]
  }, {
    path: 'seed-service',
    component: ParentView,
    redirect: '/pet/seed-service/video',
    name: 'SeedServiceGroup',
    meta: {
      title: '种公内容与团购'
    },
    children: [{
      path: 'video',
      name: 'SeedServiceVideo',
      component: seedVideo,
      meta: {
        title: '短视频内容'
      }
    }, {
      path: 'comment',
      name: 'SeedServiceComment',
      component: seedComment,
      meta: {
        title: '评论审核'
      }
    }, {
      path: 'package',
      name: 'SeedServicePackage',
      component: seedPackage,
      meta: {
        title: '团购套餐'
      }
    }, {
      path: 'fulfillment',
      name: 'SeedServiceFulfillment',
      component: seedFulfillment,
      meta: {
        title: '团购履约'
      }
    }]
  }, {
    path: 'live/item',
    name: 'PetLiveItemDirect',
    component: liveItem,
    meta: {
      title: '活体审核'
    }
  }, {
    path: 'live/order',
    name: 'PetLiveOrderDirect',
    component: liveOrder,
    hidden: true,
    meta: {
      title: '活体订单'
    }
  }, {
    path: 'live/contract',
    name: 'PetLiveContractDirect',
    component: liveContract,
    hidden: true,
    meta: {
      title: '合同记录'
    }
  }, {
    path: 'live/auction',
    name: 'PetLiveAuctionDirect',
    component: liveAuction,
    hidden: true,
    meta: {
      title: '拍卖管理'
    }
  }, {
    path: 'store_auction',
    component: ParentView,
    redirect: '/pet/store_auction/index',
    name: 'PetAuctionGroup',
    meta: {
      title: '拍卖活动'
    },
    children: [{
      path: 'index',
      alias: 'auction/product',
      name: 'PetStoreAuction',
      component: storeAuctionIndex,
      meta: {
        title: '拍卖商品'
      }
    }, {
      path: 'auction_list',
      alias: 'auction/list',
      name: 'PetAuctionList',
      component: storeAuctionList,
      hidden: true,
      meta: {
        title: '拍卖列表',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'log',
      alias: 'auction/log',
      name: 'PetAuctionLog',
      component: storeAuctionLog,
      hidden: true,
      meta: {
        title: '出价记录',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'deposit',
      alias: 'auction/deposit',
      name: 'PetAuctionDeposit',
      component: storeAuctionDeposit,
      hidden: true,
      meta: {
        title: '保证金记录',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'extract',
      alias: 'auction/extract',
      name: 'PetAuctionExtract',
      component: storeAuctionExtract,
      hidden: true,
      meta: {
        title: '提现申请',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'PetStoreAuctionCreate',
      component: storeAuctionForm,
      hidden: true,
      meta: {
        title: '添加拍卖',
        moduleKey: 'auction',
        noCache: true,
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'statistics/:id?',
      name: 'PetStoreAuctionStatistics',
      component: storeAuctionStatistics,
      hidden: true,
      meta: {
        title: '拍卖统计',
        noCache: true,
        activeMenu: '/pet/store_auction/auction_list'
      }
    }]
  }, {
    path: 'store_pet',
    component: ParentView,
    redirect: '/pet/store_pet/index',
    name: 'PetInfoGroup',
    meta: {
      title: '宠物信息'
    },
    children: [{
      path: 'index',
      alias: 'info/list',
      name: 'PetStorePet',
      component: petInfoIndex,
      meta: {
        title: '宠物信息列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'PetStorePetCreate',
      component: petInfoForm,
      hidden: true,
      meta: {
        title: '添加宠物信息',
        noCache: true,
        activeMenu: '/pet/store_pet/index'
      }
    }, {
      path: 'statistics/:id?',
      name: 'PetStorePetStatistics',
      component: petInfoStatistics,
      hidden: true,
      meta: {
        title: '宠物信息统计',
        noCache: true,
        activeMenu: '/pet/store_pet/index'
      }
    }, {
      path: 'setup_pet/:type?/:tab_id?',
      alias: 'info/config',
      name: 'PetStorePetConfig',
      component: petInfoSetup,
      meta: {
        title: '信息设置'
      }
    }, {
      path: 'top',
      alias: 'info/top',
      name: 'PetStorePetTop',
      component: petInfoTop,
      meta: {
        title: '信息置顶'
      }
    }]
  }, {
    path: 'pet_classify',
    alias: 'info/category',
    name: 'PetClassify',
    component: petClassify,
    meta: {
      title: '宠物分类'
    }
  }, {
    path: 'product_list',
    alias: 'info/live/item',
    name: 'PetProductList',
    component: liveItem,
    meta: {
      title: '活体商品'
    }
  }, {
    path: 'add_product/:id?',
    name: 'PetProductAdd',
    component: productForm,
    hidden: true,
    meta: {
      title: '添加商品',
      noCache: true,
      activeMenu: '/pet/product_list'
    }
  }, {
    path: 'product_attr',
    name: 'PetProductAttr',
    component: function component() {
      return import('@/views/product/attr/index');
    },
    hidden: true,
    meta: {
      title: '商品规格',
      activeMenu: '/pet/product_list'
    }
  }, {
    path: 'product_brand',
    name: 'PetProductBrand',
    component: function component() {
      return import('@/views/product/brand/index');
    },
    hidden: true,
    meta: {
      title: '品牌管理',
      activeMenu: '/pet/product_list'
    }
  }, {
    path: 'info/live/contract',
    name: 'PetLiveContract',
    component: liveContract,
    hidden: true,
    meta: {
      title: '合同记录',
      noCache: true,
      activeMenu: '/pet/order'
    }
  }, {
    path: 'order',
    alias: ['info/order', 'info/live/order'],
    name: 'PetOrder',
    component: petOrder,
    meta: {
      title: '宠物订单'
    }
  }, {
    path: 'store_pet_ration',
    component: ParentView,
    redirect: '/pet/store_pet_ration/index',
    name: 'PetRationGroup',
    meta: {
      title: '口粮信息'
    },
    children: [{
      path: 'index',
      alias: 'info/ration',
      name: 'PetStorePetRation',
      component: petRationIndex,
      meta: {
        title: '口粮列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'PetStorePetRationCreate',
      component: storeRationForm,
      hidden: true,
      meta: {
        title: '添加口粮信息',
        moduleKey: 'ration',
        noCache: true,
        activeMenu: '/pet/store_pet_ration/index'
      }
    }, {
      path: '/pet/store_pet/label',
      alias: 'info/label',
      name: 'PetStorePetLabel',
      component: petLabel,
      meta: {
        title: '客户来源'
      }
    }, {
      path: '/pet/store_pet/userlist',
      alias: 'info/user',
      name: 'PetStorePetUserList',
      component: petUserIndex,
      meta: {
        title: '派送员列表'
      }
    }]
  }, {
    path: 'store_pet/set/:id?',
    alias: 'info/coin/config',
    name: 'PetStorePetSet',
    component: petCoinConfig,
    meta: {
      title: '宠币设置'
    }
  }, {
    path: 'store_pet/record',
    alias: 'info/coin/record',
    name: 'PetStorePetRecord',
    component: petRecord,
    meta: {
      title: '宠币记录'
    }
  }, {
    path: 'store_pet_house',
    component: ParentView,
    redirect: '/pet/store_pet_house/index',
    name: 'PetHouseGroup',
    meta: {
      title: '宠舍管理'
    },
    children: [{
      path: 'index',
      alias: 'house/list',
      name: 'PetStorePetHouse',
      component: storePetHouseIndex,
      meta: {
        title: '宠舍列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'PetStorePetHouseCreate',
      component: storePetHouseForm,
      hidden: true,
      meta: {
        title: '添加宠舍',
        noCache: true,
        activeMenu: '/pet/store_pet_house/index'
      }
    }, {
      path: '/pet/pet_house_classify',
      alias: 'house/category',
      name: 'PetHouseClassify',
      component: petHouseClassify,
      meta: {
        title: '宠舍分类'
      }
    }, {
      path: 'record/index/:id?',
      alias: 'house/log',
      name: 'PetStorePetHouseLog',
      component: storePetHouseLog,
      meta: {
        title: '咨询记录'
      }
    }, {
      path: 'seed_order',
      alias: 'house/order',
      name: 'PetStorePetHouseOrder',
      component: storePetHouseSeedOrderIndex,
      meta: {
        title: '种公购买记录'
      }
    }, {
      path: 'rule_log',
      alias: 'house/rule-log',
      name: 'PetStorePetHouseRuleLog',
      component: petHouseRuleLog,
      meta: {
        title: '违规扣分记录'
      }
    }, {
      path: '/pet/store_pet_house_vote/index',
      alias: 'house/vote',
      name: 'PetStorePetHouseVote',
      component: houseVoteIndex,
      meta: {
        title: '投票列表'
      }
    }, {
      path: '/pet/store_pet_house_vote/create/:id?/:copy?',
      name: 'PetStorePetHouseVoteCreate',
      component: houseVoteForm,
      hidden: true,
      meta: {
        title: '添加投票',
        noCache: true,
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_user/:id?',
      alias: 'house/vote/user',
      name: 'PetVoteUser',
      component: houseVoteUser,
      hidden: true,
      meta: {
        title: '报名列表',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_rewards/:id?',
      alias: 'house/vote/rewards',
      name: 'PetVoteRewards',
      component: houseVoteRewards,
      hidden: true,
      meta: {
        title: '奖励列表',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_seed/:id?',
      alias: 'house/vote/seed',
      name: 'PetVoteSeed',
      component: houseVoteSeed,
      hidden: true,
      meta: {
        title: '种公排行',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_house/:id?',
      alias: 'house/vote/house',
      name: 'PetVoteHouse',
      component: houseVoteHouse,
      hidden: true,
      meta: {
        title: '宠舍排行',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_log/:id?',
      alias: 'house/vote/log',
      name: 'PetVoteLog',
      component: houseVoteLog,
      hidden: true,
      meta: {
        title: '投票记录',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_top_house/:id?',
      alias: 'house/top',
      name: 'PetTopHouse',
      component: petHouseTop,
      hidden: true,
      meta: {
        title: '宠舍排行'
      }
    }, {
      path: '/pet/store_pet_rank/index',
      alias: 'house/rank',
      name: 'PetStorePetHouseRank',
      component: petHouseRankIndex,
      meta: {
        title: '排名列表'
      }
    }, {
      path: '/pet/pet_top_seed',
      alias: 'house/seed',
      name: 'PetTopSeed',
      component: petHouseSeedIndex,
      meta: {
        title: '种公排行'
      }
    }]
  }, {
    path: 'chip',
    component: ParentView,
    redirect: '/pet/chip/index',
    name: 'PetChipGroup',
    meta: {
      title: '宠物芯片'
    },
    children: [{
      path: 'index',
      alias: 'chip/list',
      name: 'PetChip',
      component: chipIndex,
      meta: {
        title: '芯片管理'
      }
    }, {
      path: 'user',
      name: 'PetChipUser',
      component: chipUser,
      meta: {
        title: '会员管理'
      }
    }, {
      path: 'vip',
      name: 'PetChipVip',
      component: chipVip,
      meta: {
        title: '购买记录'
      }
    }, {
      path: 'breeding',
      alias: 'chip/breeding',
      name: 'PetChipBreeding',
      component: chipBreeding,
      meta: {
        title: '配种管理'
      }
    }, {
      path: 'name_log',
      alias: 'chip/name-log',
      name: 'PetChipNameLog',
      component: chipNameLog,
      meta: {
        title: '宠舍变更记录'
      }
    }, {
      path: 'owner',
      name: 'PetChipOwner',
      component: chipOwner,
      meta: {
        title: '宠主变更记录'
      }
    }, {
      path: 'family/:id?',
      alias: 'chip/family',
      name: 'PetChipFamily',
      component: chipFamily,
      hidden: true,
      meta: {
        title: 'DNA'
      }
    }]
  }]
};
export default petRouter;